import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Building2, Briefcase, Users, Heart } from 'lucide-react';

const ServicesPage = () => {
  const services = [
    {
      icon: Building2,
      title: 'Business Insurance',
      description: 'Archon Insurance offers a full range of cost-effective commercial insurance and risk management solutions. From promising start-ups to established enterprises, businesses depend on Archon Insurance commercial insurance to protect them from loss.',
    },
    {
      icon: Briefcase,
      title: 'Enterprise for Small Business',
      description: 'We offer a full range of cost-effective business insurance and risk management solutions. Let us help protect everything that you have worked so hard to build.',
    },
    {
      icon: Users,
      title: 'Personal Insurance Private Client',
      description: 'Your personal insurance requirements and exposure to risk are different than your neighbors. Let our experienced team of professionals customize an insurance solution that will safeguard you and your family from life\'s unforeseen events.',
    },
    {
      icon: Heart,
      title: 'Benefits Solutions',
      description: 'Our practical experience and professional expertise prepare us to better understand the challenges facing employers and help us guide them to the best options.',
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Page Banner */}
      <div className="page-banner">
        <div className="container-wide">
          <h1>SERVICES</h1>
          <div className="breadcrumb">
            <Link to="/">Home</Link> &gt; Services
          </div>
        </div>
      </div>

      {/* Hero Section with Background */}
      <section 
        className="hero-section"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1920&q=80')`,
        }}
        data-testid="services-hero"
      >
        <div className="hero-content">
          <div className="container-wide">
            <h1 className="main-heading">Let us help you with all your insurance needs.</h1>
            <p className="sub-heading">Then, Now & Always</p>
            
            {/* Service Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
              {services.map((service, index) => (
                <div key={index} className="service-card" data-testid={`service-card-${index}`}>
                  <service.icon className="service-card-icon" strokeWidth={1} />
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <Link to="/quote" className="service-card-btn">
                    Let Us Help
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
